import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

const SEO = ({ description, lang, meta, title, slug, image }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            image
          }
        }
      }
    `,
  )

  const metaDescription = description || site.siteMetadata.description
  const { siteUrl } = site.siteMetadata
  const ogImage = site.siteMetadata.siteUrl + (image || site.siteMetadata.image)

  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{title}</title>
      <meta itemProp="name" content="Sipreads" />
      <meta itemProp="description" content="Takeaways from nonfiction books." />
      <meta itemProp="image" content={ogImage} />
      <meta property="og:title" content={title} />
      <meta name="twitter:title" content={title} />
      <meta property="og:url" content={`${siteUrl}/${slug}`} />
      <meta name="description" content={metaDescription} />
      <meta property="og:description" content={metaDescription} />
      <meta name="twitter:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="og:image" content={ogImage} />
      <meta property="twitter:image" content={ogImage} />
      <meta property="twitter:site" content="sipreads" />
      <meta property="image" content={ogImage} />
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  description: '',
  slug: '',
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  slug: PropTypes.string,
}

export default SEO
